export const normalizeNumber = (
  value: string | number | null | undefined,
): number | null => {
  if (value === null || value === undefined || value === "") {
    return null;
  }

  if (typeof value === "number") {
    return Number.isFinite(value) ? value : null;
  }

  const normalizedValue = value.trim().replace(",", ".");
  if (!/^[+-]?(?:\d+|\d*\.\d+)$/.test(normalizedValue)) return null;

  const parsedValue = Number(normalizedValue);
  return Number.isFinite(parsedValue) ? parsedValue : null;
};

export const decimalToPercent = (
  decimal: number | null | undefined,
  fallbackPercent: number,
): number => {
  if (decimal === null || decimal === undefined) return fallbackPercent;

  return Math.round((decimal * 100 + Number.EPSILON) * 100) / 100;
};

export const percentToDecimalString = (
  percent: number | null | undefined,
  fallbackPercent: number,
): string => {
  const normalizedPercent = (percent ?? fallbackPercent) / 100;
  const roundedValue = Math.round(normalizedPercent * 1e6) / 1e6;

  return String(roundedValue);
};
